import { c as _c } from "react/compiler-runtime";
import React, { CSSProperties, useState } from 'react';
import { MdDelete } from 'react-icons/md';
import { useTranslations } from 'next-intl';
import NextImage from 'next/image';
import { BasicResource } from '../../types/types';
interface PropTypes {
  style?: CSSProperties;
  data: BasicResource;
  onClick?: (event?: React.MouseEvent<HTMLElement>) => void;
  onDelete?: React.MouseEventHandler<HTMLElement> | undefined;
}
function EpisodeItem(t0) {
  const $ = _c(28);
  const {
    data,
    onClick,
    onDelete
  } = t0;
  const t = useTranslations();
  const [loadFallback, setLoadFallback] = useState(false);
  const seasonNumber = data.season_number && data.season_number < 10 ? "0" + data.season_number : data.season_number;
  const episodeNumber = data.episode_number && data?.episode_number < 10 ? "0" + data.episode_number : data.episode_number;
  let t1;
  if ($[0] !== data.title || $[1] !== t) {
    t1 = t("images_alts.episode_poster", {
      title: data.title
    });
    $[0] = data.title;
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = loadFallback || !data.tv?.poster ? "/assets/app/poster-fallback.jpg" : `https://cdn-proxy.trakio.app/t/p/w220_and_h330_face${data?.tv?.poster?.file_path}`;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      setLoadFallback(true);
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== onClick || $[5] !== t1 || $[6] !== t2) {
    t4 = <NextImage className="hover:opacity-[0.4] transition-all duration-200 rounded-md" onClick={onClick} alt={t1} src={t2} onError={t3} width={140} height={210} sizes={"\n            (min-width: 300px) 100px,150px\n            (min-width: 768px) 140px,210px"} unoptimized={true} />;
    $[4] = onClick;
    $[5] = t1;
    $[6] = t2;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== onDelete) {
    t5 = onDelete && <button className="absolute top-2 right-2 w-[30px] h-[30px] rounded-full transition-all duration-200 bg-white text-black hover:bg-gray-200" onClick={onDelete}><MdDelete size={14} /></button>;
    $[8] = onDelete;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t4 || $[11] !== t5) {
    t6 = <div className="w-full h-auto bg-gray-400 rounded-md cursor-pointer img-wrapper">{t4}{t5}</div>;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const t7 = data.tv?.title;
  let t8;
  if ($[13] !== onClick || $[14] !== t7) {
    t8 = <span className="text-white font-bold text-center cursor-pointer w-full px-2 line-clamp-2 mt-1" onClick={onClick}>{t7}</span>;
    $[13] = onClick;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  const t9 = seasonNumber as number;
  const t10 = episodeNumber as number;
  let t11;
  if ($[16] !== t || $[17] !== t10 || $[18] !== t9) {
    t11 = t("common.episode_season_tag", {
      season: t9,
      episode: t10
    });
    $[16] = t;
    $[17] = t10;
    $[18] = t9;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== data.title || $[21] !== onClick || $[22] !== t11) {
    t12 = <span className="text-white font-bold text-center cursor-pointer w-full px-2 line-clamp-1 mt-1" onClick={onClick}>{t11}{" "}{data.title}</span>;
    $[20] = data.title;
    $[21] = onClick;
    $[22] = t11;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== t12 || $[25] !== t6 || $[26] !== t8) {
    t13 = <div className="flex flex-col items-center relative title-item">{t6}{t8}{t12}</div>;
    $[24] = t12;
    $[25] = t6;
    $[26] = t8;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  return t13;
}
export default React.memo(EpisodeItem);